var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications notifications__modified"},_vm._l((_vm.notifications),function(v,idx){return _c('notification',{key:_vm.notifications[idx].nIdx,on:{"close":function($event){return _vm.onNotificationCloseRequested(idx)}},model:{value:(_vm.notifications[idx]),callback:function ($$v) {_vm.$set(_vm.notifications, idx, $$v)},expression:"notifications[idx]"}})}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f482c01","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/notifications/notifications.vue
// module id = 548
// module chunks = 1